import { Component, ElementRef, ViewChild, signal, effect } from '@angular/core';

import { BackendApi } from '../shared/backend-api';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AskAIResponseDTO } from '../shared/preventivo';

export type Role = 'user' | 'assistant';

export interface Message {
  role: Role;
  content: string;
  id?: string;
  createdAt?: string;
}

@Component({
  selector: 'app-chat',
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './chat.html',
  styleUrl: './chat.css'
})

export class Chat {
  messages = signal<Message[]>([
    { role: 'assistant', content: 'Ciao! Hai dubbi o domande? Chiedi pure.' }
  ]);
  input = signal<string>('');
  isLoading = signal<boolean>(false);
  errore = signal<string | null>(null);

  response: AskAIResponseDTO | null = null;

  @ViewChild('scrollArea') scrollArea!: ElementRef<HTMLDivElement>;

  constructor(
    private api: BackendApi
  ) 
  {
    effect(() => {
      this.messages();
      queueMicrotask(() => this.scrollToBottom());
    });
  }

  send(): void {
    const text = this.input().trim();
    if (!text || this.isLoading()) return;

    // Aggiungo il messaggio utente in UI
    const userMsg: Message = { role: 'user', content: text };
    this.messages.update(m => [...m, userMsg]);
    this.input.set('');
    this.isLoading.set(true);
    this.errore.set(null);

    // Valutare per lo storico
    // potresi mandare tutti i messaggi come request
    // this.messages()

    const body = {
      message: userMsg.content
    };

    this.api.askAI(body).subscribe({
      next: (res) => {
        this.response = res;
        const replyMsg: Message = { role: 'assistant', content: res.reply! };
        this.messages.update(m => [...m, replyMsg]);
        this.isLoading.set(false);
      },
      error: (err) => {
        this.errore.set('Errore durante la richiesta al backend. Riprova più tardi.');
        this.isLoading.set(false);
      }
    });
  }

  handleKeydown(e: KeyboardEvent) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      this.send();
    }
  }

  bubbleClasses(msg: Message) {
    const base = 'max-w-[80%] rounded-2xl px-4 py-2 shadow whitespace-pre-wrap break-words';
    return msg.role === 'user'
      ? `${base} bg-blue-600 text-white rounded-br-md`
      : `${base} bg-gray-100 text-gray-900 rounded-bl-md`;
  }

  private scrollToBottom() {
    const el = this.scrollArea?.nativeElement;
    if (el) el.scrollTop = el.scrollHeight;
  }
}
